/* ONE BLACKJACK rules — texts only (image fields intentionally left empty) */
export const list = [
    {
        id: 1,
        title: "Правила игры",
        content:
            <div className="content">

                <p>
                    <b>БЛЕК ДЖЕК</b>
                    <br /><br />
                    Блек Джек – очень простая и захватывающая игра. Цель игры набрать наиболее близкое к 21 количество очков. Игрок делает ставки на обозначенную на столе позицию (Bet) в пределах минимума и максимума стола.
                </p>

                <p>После того, как ставки сделаны игрок получает две карты, у дилера также две карты, одна из которых закрыта. Все картинки оцениваются в 10 очков, Туз – 11 или 1 очко, остальные карты оцениваются по их номиналу. На основании полученных карт игрок принимает решение, брать дополнительные карты или остановиться. Если сумма очков игрока превышает 21, то он проигрывает. Игрок не может взять карту, если сумма очков на боксе составляет 21.</p>

                <p>После того, как игрок принял решение, дилер набирает карты себе. Дилер продолжает набирать карты на 16 и меньше и останавливается на 17 и больше. Если общая сумма очков игрока превышает сумму очков дилера, но не больше 21, он выигрывает, и наоборот. Если игрок и дилер набирают равное количество очков, объявляется Ничья «Stand off» (никто не выигрывает и не проигрывает).</p>

                <p>«Блек Джек» – комбинация из туза и карты достоинством 10 очков на первых двух картах; сразу оплачивается 3:2, кроме случаев, когда карта дилера – туз или карта достоинством 10 очков. Все остальные выигравшие комбинации оплачиваются 1:1.</p>

                <p>«Блек Джек» – самая старшая комбинация. «Блек Джек» никогда не проигрывает. Если у дилера и игрока «Блек Джек» – возникает ситуация «Stand off».</p>

                <p style={{ fontWeight: 700 }}>Double (Удвоение)</p>
                <p>Имея любую сумму очков на первых двух картах, кроме «Блек Джек», вы можете удвоить свою ставку. После этого вы можете получить только одну карту независимо от ее достоинства. Рискуйте, и двойной выигрыш – Ваш!</p>

                <p style={{ fontWeight: 700 }}>Split (Разделение)</p>
                <p>Если первые две карты игрока имеют одинаковое достоинство, то он может сделать «Split» - разделить две карты, доставив при этом ставку, равную первоначальной, и набирать карты на каждую из них отдельно. При сплите Тузов на каждый Туз дается только по одной карте. Когда на Туз после разделения приходит десятка, это не является комбинацией «Блек Джек», а считается как «21».</p>

                <p style={{ fontWeight: 700 }}>Страхование</p>
                <p>Если карта дилера – Туз, а у игрока обычная комбинация, игрок может застраховаться от «Блек Джека» у дилера, поставив дополнительную ставку в размере половины от первоначальной ставки.</p>
                <p>Если у дилера «Блек Джек», то страховка оплачивается 2:1, в противном случае она проигрывает.</p>

                <p style={{ fontWeight: 700 }}>Even Money (Равные деньги)</p>
                <p>Если у игрока «Блек Джек», а открытая карта дилера – Туз, вместо страховки предлагается Even Money:</p>
                <p>• «Да» – игроку сразу выплачивается выигрыш 1:1 (равный его ставке), независимо от карт дилера.</p>
                <p>• «Нет» и у дилера «Блек Джек» – объявляется Ничья.</p>
                <p>• «Нет» и у дилера комбинация ниже или перебор – «Блек Джек» игрока оплачивается 3:2.</p>

                <p>Таблица выплат</p>
                <table className="rules-table">
                    <tbody>
                        <tr><td>BEST HAND</td><td>1:1</td></tr>
                        <tr><td>СТРАХОВКА</td><td>2:1</td></tr>
                        <tr><td>EVEN MONEY</td><td>1:1</td></tr>
                        <tr><td>BLACKJACK</td><td>3:2</td></tr>
                    </tbody>
                </table>

            </div>,
    },
    {
        id: 2,
        title: "Дополнительные ставки",
        content:
            <div className="content">
                <p style={{ fontWeight: 700 }}>21+3</p>
                <p>Дополнительная ставка «21+3» выигрывает, если с первых двух карт игрока и открытой карты дилера образовывается три карты одного номинала одной масти, либо три карты подряд одной масти, либо три карты одного номинала, либо три карты подряд, либо три карты одной масти и оплачивается в соответствии с таблицей выплат.</p>

                <p>Таблица выплат для 21+3</p>
                <table className="rules-table">
                    <tbody>
                        <tr><td>SUITED TRIPS</td><td>100:1</td></tr>
                        <tr><td>СТРИТ ФЛЭШ</td><td>40:1</td></tr>
                        <tr><td>ТРОЙКА</td><td>30:1</td></tr>
                        <tr><td>СТРИТ</td><td>10:1</td></tr>
                        <tr><td>ФЛЭШ</td><td>5:1</td></tr>
                    </tbody>
                </table>

                <p style={{ fontWeight: 700 }}>Perfect Pair</p>
                <p>Дополнительная ставка «Perfect Pair» выигрывает, если первые две карты игрока одного номинала и одной масти, либо одного номинала и одного цвета, либо одного номинала и оплачивается в соответствии с таблицей выплат.</p>

                <p>Таблица выплат для Perfect Pair</p>
                <table className="rules-table">
                    <tbody>
                        <tr><td>PERFECT PAIR</td><td>25:1</td></tr>
                        <tr><td>COLOURED PAIR</td><td>12:1</td></tr>
                        <tr><td>MIXED PAIR</td><td>6:1</td></tr>
                    </tbody>
                </table>

                <p style={{ fontWeight: 700 }}>Bust Bonus</p>
                <p>Дополнительная ставка на то, что у дилера обязательно будет перебор. Выигрыш зависит от того, с какого количества карт будет перебор у дилера и оплачивается в соответствии с таблицей выплат. Если у игрока Блэк Джэк, то ставка на Bust Bonus возвращается.</p>

                <p>Таблица выплат для Bust Bonus</p>
                <table className="rules-table">
                    <tbody>
                        <tr><td>BUST WITH 8+ CARDS</td><td>250:1</td></tr>
                        <tr><td>BUST WITH 7 CARDS</td><td>100:1</td></tr>
                        <tr><td>BUST WITH 6 CARDS</td><td>50:1</td></tr>
                        <tr><td>BUST WITH 5 CARDS</td><td>9:1</td></tr>
                        <tr><td>BUST WITH 4 CARDS</td><td>2:1</td></tr>
                        <tr><td>BUST WITH 3 CARDS</td><td>1:1</td></tr>
                    </tbody>
                </table>

                <p style={{ fontWeight: 700 }}>Crazy 7</p>
                <p>Дополнительная ставка на то, что игроку первой, а за тем второй и третьей картой будут розданы «Семерки». Если после «Split» семерок следующая карта семерка, то у вас три семерки. Ставка оплачивается в соответствии с таблицей выплат.</p>
                <p>Таблица выплат для Crazy 7</p>
                <table className="rules-table">
                    <tbody>
                        <tr><td>7-7-7 SUITED</td><td>2000:1</td></tr>
                        <tr><td>7-7-7</td><td>500:1</td></tr>
                        <tr><td>7-7 SUITED</td><td>150:1</td></tr>
                        <tr><td>7-7</td><td>25:1</td></tr>
                        <tr><td>7</td><td>5:1</td></tr>
                    </tbody>
                </table>
            </div>,
    },
    {
        id: 3,
        title: "Делайте ставки",
        content:
            <div className="content">
                <p>Панель «ЛИМИТЫ СТАВОК» отображает минимальные и максимальные разрешенные лимиты ставок за столом, которые могут время от времени меняться.</p>
                <p>Для участия в игре вам потребуется достаточное количество средств, необходимое для покрытия ставок. Ваш текущий БАЛАНС отображается на экране.</p>
                <p>Индикатор «ОТОБРАЖЕНИЕ ФИШЕК» позволяет выбирать достоинство каждой фишки, которую захотите разместить в виде ставки. Для выбора доступны только те фишки, номинал которых может быть покрыт вашим текущим балансом.</p>
                <p>После выбора фишки сделайте ставку, нажав на соответствующее место для ставки на игровом столе. При каждом нажатии сумма вашей ставки увеличивается на стоимость выбранной фишки или до максимально допустимого лимита для выбранного типа ставки.</p>
                <p>ПРИМЕЧАНИЕ: Пожалуйста, не сворачивайте окно браузера и не открывайте другие вкладки, пока активно время размещения ставок. Такие действия могут быть расценены как выход из игры, и ваши ставки будут отклонены в этом раунде.</p>
                <p>Кнопка «ПОВТОРИТЬ» позволяет повторить все ставки из предыдущего раунда игры. Эта кнопка остается активной до тех пор, пока не будет размещена первая фишка.</p>
                <p>Кнопка «УДВОИТЬ» (2×) становится доступной после размещения ставки. С каждым нажатием все ваши ставки удваиваются вплоть до максимального предела.</p>
                <p>Кнопка «ОТМЕНА» позволяет удалить последнюю размещенную ставку. Повторное нажатие отменяет ставки по одной в обратном порядке.</p>
                <p>Кнопка «ОЧИСТИТЬ» позволяет удалить все размещенные ставки.</p>
                <p>Индикатор «ОБЩАЯ СТАВКА» отображает общую сумму ставок, размещенных в текущем раунде.</p>
                <p>После раздачи ваших карт появится ваша комбинация карт и окно принятия решения. При тузе у дилера появится окно «Страховка».</p>
            </div>,
    },
    {
        id: 4,
        title: "Номер игры",
        content:
            <div className="content">
                <p>Каждый раунд игры идентифицируется уникальным НОМЕРОМ ИГРЫ.</p>
                <p>Пожалуйста, используйте этот номер (или сделайте снимок экрана с номером игры), если вы хотите обратиться в Службу поддержки с вопросами относительно определенного раунда.</p>
            </div>,
    },
    {
        id: 5,
        title: "Звук",
        content:
            <div className="content">
                <p>Кнопка «ЗВУК» включает/выключает все звуки игры и голоса. Примите к сведению, что в случае смены стола все звуки включатся автоматически.</p>
                <p>Вы можете изменить настройки звука, нажав кнопку «НАСТРОЙКИ» и выбрав вкладку ЗВУК.</p>
            </div>,
    },
    {
        id: 6,
        title: "История игр",
        content:
            <div className="content">
                <p>С помощью кнопки «ИСТОРИЯ» можно открыть окно, в котором будут отображены все сыгранные вами раунды игры и их результаты.</p>
                <p>Последний завершенный раунд отображается в самом верху списка.</p>
            </div>,
    },
    {
        id: 7,
        title: "Действия в случае сбоя",
        content:
            <div className="content">
                <p>При сбоях в игре, игровой системе или процедуре игры раунд временно приостанавливается, а ведущий игры уведомляет об этом сервис-менеджера. Вы и другие игроки увидите сообщение в чате или всплывающее сообщение на экране о том, что данный вопрос рассматривается. Если менеджер сможет незамедлительно устранить ошибку, раунд игры продолжится, как обычно. В случае отсутствия возможности незамедлительного устранения раунд игры аннулируется, а изначальные ставки подлежат возмещению всем игрокам, принявшим в нем участие.</p>
            </div>,
    },
    {
        id: 8,
        title: "Политика отключения",
        content:
            <div className="content">
                <p>В случае отключения от игры до истечения времени для размещения ставок любые сделанные ставки признаются недействительными и возвращаются вам. В случае отключения после истечения времени для размещения ставок, сделанные ставки признаются действительными и разыгрываются без вашего участия. Результаты розыгрыша ставки можно посмотреть в окне «История» после повторного подключения.</p>
            </div>,
    },
]
